// Custom Code for sliding cart

// Assign default values to shipping protection added
var shipUser = localStorage.getItem("shipUser");
var shippingProtectionAuto = localStorage.getItem("shipAuto");
if(shipUser != "true" && shipUser != "false") {
   localStorage.setItem("shipUser", "default"); 
}
if(shippingProtectionAuto != "true" && shippingProtectionAuto != "false") {
   localStorage.setItem("shipAuto", "default"); 
}

// Open cart after successful operation
document.addEventListener("DOMContentLoaded", () => {
  
  // Open cart logic
  const cartIconBubble = document.querySelector("#cart-icon-bubble");

  // Check if the flag is set in localStorage
  if (localStorage.getItem("openCartAfterReload") === "true") {
    // Remove the flag to avoid repeated behavior
    localStorage.removeItem("openCartAfterReload");

    // Open the cart
    if (cartIconBubble) {
      cartIconBubble.click();
    }
  }
});

// Add or remove shipping protection logic based on checkbox
$(document).on('click', '#shipping-protection', function() {
  if ($("#shipping-protection").is(":checked")) {
    localStorage.setItem("shipUser", "true");
  }else {
    localStorage.setItem("shipUser", "false");
  }
  ShippingProtectionLogic(true);
});

// Check for atleast one item in the cart
function autoAddShippingProtection() {
  // Add shipping protection autmatically only for first time
  if (localStorage.getItem("shipAuto") != "true") {
    localStorage.setItem("shipAuto", "true");
    $("#shipping-protection").prop("checked", true);
    ShippingProtectionLogic(true);
  }
}

function ShippingProtectionLogic(reload) {
  console.log("Checked: ", $("#shipping-protection").is(":checked"));
  if ($("#shipping-protection").is(":checked")) {
    AddShippingProtection(1).then(() => {
      if(reload == true) {
        localStorage.setItem("openCartAfterReload", "true");
        window.location.reload();
      }
    });
  } else {
    RemoveShippingProtection().then(() => {
        localStorage.setItem("shipAuto", "false");
        if(reload == true) {
          localStorage.setItem("openCartAfterReload", "true");
          window.location.reload();
        }
        
      });
    }
}

function AddLEDTransformer(quantity, variant_id) {

  // Variant ID for the LED 12V Transformer 51304286781758
  // Variant ID for the LED 12V Transformer With Dimmer 51582638162238
  
  // Default quantity to 1 if not provided
  const productQuantity = quantity || 1;

  // Fetch request to add the second product to the cart
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variant_id, 
      quantity: productQuantity
    })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add LED Transformer to the cart.');
      }
      return response.json();
    })
    .then(data => {
      console.log(`Added LED Transformer to cart with quantity: ${productQuantity}`, data);
      return data; // Return the response for further chaining if needed
    })
    .catch(error => {
      console.error('Error adding LED Transformer to the cart:', error);
      throw error; // Re-throw the error to handle it in the caller
    });
}

function AddShippingProtection(quantity) {
  // Default quantity to 1 if not provided
  const productQuantity = quantity || 1;

  // Fetch request to add the second product to the cart
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: 51153925833022, // Variant ID for Shipping Protection 51153925833022
      quantity: productQuantity
    })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add Shipping Protection to the cart.');
      }
      return response.json();
    })
    .then(data => {
      console.log(`Added Shipping Protection to cart with quantity: ${productQuantity}`, data);
      return data; // Return the response for further chaining if needed
    })
    .catch(error => {
      console.error('Error adding Shipping Protection to the cart:', error);
      throw error; // Re-throw the error to handle it in the caller
    });
}
function RemoveShippingProtection() {
  return fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch cart data.');
      }
      return response.json();
    })
    .then(cart => {
      // Find the LED Transformer product in the cart
      const shipProtectionItem = cart.items.find(item => item.id === 51153925833022);
      
      if (!shipProtectionItem) {
        console.log('Shipping Protection is not in the cart.');
        return; // Exit if the item is not in the cart
      }

      // Calculate the new quantity (decrease by 1)
      const newQuantity = shipProtectionItem.quantity - 1;

      // If the new quantity is 0, remove the item completely
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: shipProtectionItem.key, // Use the unique line item key
          quantity: newQuantity > 0 ? newQuantity : 0 // Ensure quantity is not negative
        })
      });
    })
    .then(response => {
      if (response && !response.ok) {
        throw new Error('Failed to update Shipping Protection quantity.');
      }
      return response ? response.json() : null;
    })
    .then(data => {
      console.log('Reduced Shipping Protection quantity by 1:', data);
      return data;
    })
    .catch(error => {
      console.error('Error reducing Shipping Protection quantity:', error);
    });
}

function UpdateLEDTransformerQuantity(quantityChange) {
  // Get the current quantity of the LED Transformer in the cart
  return fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch cart data.');
      }
      return response.json();
    })
    .then(cart => {
      // Find the LED Transformer product in the cart
      const transformerItem = cart.items.find(item => item.id === 51304286781758);
      
      if (!transformerItem) {
        throw new Error('LED Transformer is not in the cart.');
      }

      // Calculate the new quantity
      const newQuantity = transformerItem.quantity + quantityChange;

      // Ensure the quantity doesn't go below zero
      if (newQuantity < 0) {
        throw new Error('Quantity cannot be negative.');
      }

      // Update the quantity using the line item key
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: transformerItem.key, // Use the line item key instead of variant_id
          quantity: quantityChange
        })
      });
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to update LED Transformer quantity.');
      }
      return response.json();
    })
    .then(data => {
      console.log('Updated LED Transformer quantity:', data);
      return data;
    })
    .catch(error => {
      console.error('Error updating LED Transformer quantity:', error);
      throw error;
    });
}

function RemoveLEDTransformer() {
  return fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch cart data.');
      }
      return response.json();
    })
    .then(cart => {
      // Find the LED Transformer product in the cart
      const transformerItem = cart.items.find(item => item.id === 51304286781758);
      
      if (!transformerItem) {
        console.log('LED Transformer is not in the cart.');
        return; // Exit if the item is not in the cart
      }

      // Calculate the new quantity (decrease by 1)
      const newQuantity = transformerItem.quantity - 1;

      // If the new quantity is 0, remove the item completely
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: transformerItem.key, // Use the unique line item key
          quantity: newQuantity > 0 ? newQuantity : 0 // Ensure quantity is not negative
        })
      });
    })
    .then(response => {
      if (response && !response.ok) {
        throw new Error('Failed to update LED Transformer quantity.');
      }
      return response ? response.json() : null;
    })
    .then(data => {
      console.log('Reduced LED Transformer quantity by 1:', data);
      localStorage.setItem("openCartAfterReload", "true");
      window.location.reload();
    //   setTimeout(function() {
    //     refreshCart();
    // }, 2000);
      // return data;
    })
    .catch(error => {
      console.error('Error reducing LED Transformer quantity:', error);
    });
}

function RemoveSignProduct(variantId) {
  return fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch cart data.');
      }
      return response.json();
    })
    .then(cart => {
      // Find the LED Transformer product in the cart
      const signItem = cart.items.find(item => item.id === variantId);
      
      if (!signItem) {
        console.log('Sign Item is not in the cart.');
        return; // Exit if the item is not in the cart
      }

      // Calculate the new quantity (decrease by 1)
      const newQuantity = signItem.quantity - 1;

      // If the new quantity is 0, remove the item completely
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: signItem.key, // Use the unique line item key
          quantity: newQuantity > 0 ? newQuantity : 0 // Ensure quantity is not negative
        })
      });
    })
    .then(response => {
      if (response && !response.ok) {
        throw new Error('Failed to delete Sign Item.');
      }
      return response ? response.json() : null;
    })
    .then(data => {
      console.log('Reduced LED Transformer quantity by 1:', data);
      localStorage.setItem("openCartAfterReload", "true");
      // window.location.reload();
      setTimeout(function() {
        refreshCart();
    }, 2000);
      // return data;
    })
    .catch(error => {
      console.error('Error reducing LED Transformer quantity:', error);
    });
}


// Add or subtract transformer when quantity changes
// $(document).on('click', '.quantity__button', function() {
//   const buttonName = $(this).attr('name'); // Get the 'name' attribute of the button
//   if (buttonName === 'minus') {
//     // Minus LED Transformer
//     UpdateLEDTransformerQuantity(-1).then(() => {
//       console.log('Reduced LED Transformer quantity by 1.');
//     });
//   } else if (buttonName === 'plus') {
//     // Add LED Transformer
//     UpdateLEDTransformerQuantity(1).then(() => {
//       console.log('Increased LED Transformer quantity by 1.');
//     });
//   } else {
//     console.log('Unknown button clicked');
//   }
// });

// Remove one LED transformer when one prodcut is deleted 
// $(document).on('click', '.CartRemove-Button', function() {

//   let x = $(this).parent().parent().parent().find(".cart-item__details").find(".product-option.LEDs dd").html();
//   console.log(x);
//   if(x != "None" && x.length) {
//     RemoveLEDTransformer().then(() => {
//       // localStorage.setItem("openCartAfterReload", "true");
//       // window.location.reload();
//       // setTimeout(function() {
//       //     console.log("This function runs after 2 seconds!");
//       //     window.location.reload();
//       // }, 2000); // 2000 milliseconds = 2 seconds

//     });
//   }else{
//     console.log("No Light product");
//     setTimeout(function() {
//         refreshCart();
//     }, 2000);
    
//   }
  
// });

// Store state of shipping protection
// const checkShipProtection = document.getElementById("shipping-protection");
// if (((localStorage.getItem("shipAuto") == "true")) && (checkShipProtection != null)) {
//     checkShipProtection.checked = true;
// }

function sortCartItems() {
    let tableBody = document.querySelector(".cart-items tbody");
    if(tableBody) {
      let rows = Array.from(tableBody.querySelectorAll("tr"));
      if(rows) {
        rows.sort((a, b) => {
          return a.dataset.transformer === "true" ? 1 : -1;
        });

        // Reinsert rows in sorted order
        rows.forEach(row => tableBody.appendChild(row));
      }
    }
    
}

function refreshCart() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      console.log("Cart refreshed:");
      // console.log("Cart refreshed:", cart);
      
      // Check if cart has only one item and that item is "Shipping Protection"
      if (cart.item_count === 1 && cart.items[0].product_title.includes("Shipping Protection")) {
        // window.location.reload();
        showEmptyCart(); // Treat as an empty cart
        // Remove shipping protection when it is the only item in the cart
        RemoveShippingProtection().then(() => {
          localStorage.setItem("shipAuto", "false");
          window.location.reload();
        });
      } 
      else {

        // Check for atleast one item in the cart and include shipping protection        
        let adjustedCount = cart.item_count;
        let shipItemFound = "false";
        const checkShipProtection = document.getElementById("shipping-protection");
        cart.items.forEach(item => {
            if (item.product_title.includes("Shipping Protection")) {
                adjustedCount -= 1;

                // Get the price of the "Shipping Protection" item
                const price = item.final_line_price / 100; // Convert from cents to dollars
                const formattedPrice = price.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                $("#shipProtectionPrice").html(cart.currency + " " + formattedPrice);
                console.log("Shipping Protection Price:", cart.currency + " " + formattedPrice);
                shipItemFound = "true";
                checkShipProtection.checked = true;
            }
        });
        $('.cart-count-bubble span:first-child').text(adjustedCount);
        $(".drawer__footer").show();

        if(shipItemFound == "false") {
          checkShipProtection.checked = false;
          if(cart.item_count != 0) {
            if (localStorage.getItem("shipUser") == "default") {
              autoAddShippingProtection();
            }  
          }
        }
      }
    },
    error: function(error) {
      console.error("Error fetching cart contents:", error);
    }
  });
}

function showEmptyCart() {
  // Set cart count to 0
  $('.cart-count-bubble span:first-child').text(0);
  $(".drawer").addClass('is-empty');
  $(".drawer__footer").hide();
}

// Call refreshCart on page load
$(document).ready(function() {
  refreshCart();
});

// Login to delete the sign product and led transformer if lights are also added
$(document).on('click', '.CartRemove-Button', function (e) {
    e.preventDefault();
    console.log("Cart button event fired");

    let $this = $(this);
    let lineItemId = $this.data('line-item'); // Get the line item index
    let variantId = $this.data('variant-id'); // Get the line item index
    console.log(lineItemId);
    console.log(variantId);
    let x = $(this).parent().parent().parent().find(".cart-item__details").find(".product-option.LEDs dd").html();

    $(this).find("button").addClass("remove-animate");
    RemoveSignProduct(variantId).then(() => {
      $(this).find("button").removeClass("remove-animate");
      window.location.reload();
      // if(x != "None" && x.length) {
      //   RemoveLEDTransformer();
      // }else{
      //   console.log("No Light product");
      //   window.location.reload();
      // }
      // $(this).find("button").removeClass("remove-animate");
    });
});

function convertToSVG() {
    setTimeout(() => {
      const targetDiv = document.getElementById("capture");
  
      if (!targetDiv) {
          console.error("Target element #capture not found!");
          return;
      }
        html2canvas(targetDiv, { backgroundColor: null })
            .then(canvas => {
                const imgData = canvas.toDataURL("image/png");
                localStorage.setItem("savedSVGImage", imgData);
            })
            .catch(err => console.error("html2canvas error:", err));
    }, 500);  // Small delay to ensure rendering is complete
}

// $(document).on('click', '#done-btn', function() {
//   convertToSVG();
// });

